import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../lib/helpers';

import NotificationsTopbarButton from './components/NotificationsTopbarButton/NotificationsTopbarButton';

import { useNotifications } from '../../hooks/api/useNotifications';

import PageLayout from '../../layout/PageLayout/PageLayout';
import DashboardIntro from './sections/DashboardIntro';
import DashboardQuickLinks from './sections/DashboardQuickLinks';

const testId = 'home';

const HomeSlim = () => {
  const { t } = useTranslation();

  const { notifications, notificationsLoading, onNotificationsRead } =
    useNotifications();

  return (
    <PageLayout
      page="dashboard"
      id="dashboardSlim"
      title={t('Global.Dashboard')}
      buttons={
        <NotificationsTopbarButton
          notifications={notifications}
          notificationsLoading={notificationsLoading}
          onNotificationsRead={onNotificationsRead}
          {...getTestProps(testId, 'notifications', 'testId')}
        />
      }
      buttonsMobilePlacement="top"
      testId={testId}
    >
      <div className="space-y-8">
        <DashboardIntro testId={testId} />
        <DashboardQuickLinks testId={testId} />
      </div>
    </PageLayout>
  );
};

export default HomeSlim;
